const isFloat = (n) => Number(n) === n && n % 1 !== 0;
const stringToInteger = (value, fallback) => {
  try {
    return Number.parseInt(value);
  } catch (_) {
    return fallback || void 0;
  }
};

export { isFloat, stringToInteger };
